import { Box } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import RenderVertical from 'components/Organizations/RenderVertical'
import { FC } from 'react'
import { DensityStyleTypes } from 'types'

interface VerticalProps {
  params: GridRenderCellParams
  densityStyles: DensityStyleTypes
  onEditClick?: (params: GridRenderCellParams) => void
}

const VerticalCell: FC<VerticalProps> = ({ params, densityStyles, onEditClick }) => {
  const { vertical } = params?.row ?? {}
  const verticals = Array.isArray(vertical) ? vertical : [vertical]
  const firstVertical = verticals.length > 0 ? verticals[0] : 'No Vertical Assigned'
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
        // padding: densityStyles.padding,
        // gap: densityStyles.gap,
      }}
      onClick={() => onEditClick(params)}
    >
      <RenderVertical
        vertical={firstVertical}
        width={densityStyles.verticalWidth}
        height={densityStyles.verticalHeight}
        size={densityStyles.verticalSize}
      />
    </Box>
  )
}
export default VerticalCell
